import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);

// The build does not emit a service-worker.js (this is not a PWA build), and
// Firebase Hosting rewrites /service-worker.js to index.html — so register()
// fails on every load with "unsupported MIME type ('text/html')". unregister()
// is CRA's correct default for a non-PWA app: it suppresses that error and
// tears down any stale worker. Switch back to register() only alongside a real
// service-worker build. Learn more: https://bit.ly/CRA-PWA
serviceWorker.unregister();
